<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="Sensor Type" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="ការកំណត់តម្លៃ" name="second"></el-tab-pane> -->

		</el-tabs>

		<div v-if="tabName == 'second'">
			<md-table>
				<md-table-row>
					<!-- <md-table-head>n.o</md-table-head> -->
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in settingList">
					<!-- <md-table-cell>{{index + 1}}</md-table-cell> -->
					<md-table-cell>{{setting.name}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="settingList[index].value"
								:value="settingList[index].value" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">Update</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<md-table-head>N<sup>o</sup></md-table-head>
					<md-table-head>Name</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>
				<md-table-row v-for="(sensor_type, index) in sensorTypeList" v-if="sensor_type.id != 1">
					<md-table-cell>{{index}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="sensorTypeList[index].name"
								:value="sensorTypeList[index].name" @keyup.enter="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updateSensorType(index, sensor_type.id)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">Update</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="deleteSensorType(sensor_type.id)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">Delete</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>Add new</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="sensorType.name"
								:value="sensorType.name" @keyup.enter="createSensorType()">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createSensorType()">
							<md-icon>add_circle</md-icon>
							<md-tooltip md-direction="top">Add new</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getSettings();
		},
		data() {
			return {
				isValid: true,
				tabName: 'first',
				sensorTypeList: [],
				sensorType: {
					name: ""
				},
				settingList: [
					{
						id: "001",
						name: "ប្តូរប្រាក់ 1USD",
						value: 4100
					}
				]
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.sensorTypeList = data.body.data.sensor_type
				})
			},
			updateSensorType(index, sensor_type_id) {
				this.$http.post(this.config.api + "/admin/setting/sensor_type/update", {
					sensor_type_id: sensor_type_id,
					value: this.sensorTypeList[index].name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Sensor Type was updated successfully.",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			deleteSensorType(sensor_type_id) {
				this.$http.post(this.config.api + "/admin/setting/sensor_type/delete", {
					sensor_type_id: sensor_type_id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Sensor Type was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			createSensorType() {
				this.$http.post(this.config.api + "/admin/setting/sensor_type/post", {
					name: this.sensorType.name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Sensor Type was created successfully.",
							icon: 'done',
							type: 'success'
						})
						this.sensorType.name = "";
						this.getSettings();
					}
				})
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Settings/View.vue